import { Typography } from '@mui/material';
import { CalloutBox, CalloutBoxProps } from '@inmarket/inmarkit';
import { ReactNode } from 'react';

type HighlightsProps = {
  children?: ReactNode;
  sx?: CalloutBoxProps['sx'];
};

export const Highlights = (props: HighlightsProps) => {
  return (
    <CalloutBox title="Highlights" sx={props.sx} editable={false}>
      <Typography data-testid="highlights-text">{props.children}</Typography>
    </CalloutBox>
  );
};
